var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _vm.splitBubbleCollectionFormat
        ? _c(
            "el-select",
            {
              attrs: {
                value: _vm.value || "",
                disabled: _vm.disabled,
                clearable: ""
              },
              on: { input: _vm.onInput, change: _vm.onChange }
            },
            _vm._l(_vm.SPLIT_BUBBLE_COLLECT_ITEMS, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: _vm.$getLangColumn(item), value: item.code }
              })
            }),
            1
          )
        : [
            _c("el-input-number", {
              attrs: {
                value: _vm.value,
                "controls-position": "right",
                min: 0,
                max: 999999999
              },
              on: { input: _vm.onInput, change: _vm.onChange }
            }),
            _c("span", [_vm._v("%")])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }